export const HOME_SAFE = 'HomeSafe';
